import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { getBrand, mediaVariant } from "../lib/catalogueApi";
import { StoreLayout } from "./StoreLayout";
import { setPagedHead } from "./Paging";
import { NothingNow } from "./NothingNow";
import { useListing } from "./listing/useListing";
import { ListingView } from "./listing/ListingView";

// T55: logo when we have one, otherwise the T53 brand-name treatment (no invented artwork)
export const BrandMark = ({ name, logoId, size = "md", testid = "brand-mark" }) => {
  const [failed, setFailed] = useState(false);
  const big = size === "md";
  return (
    <div className={`flex shrink-0 items-center justify-center rounded-xl border border-slate-200 bg-white ${big ? "h-20 w-32" : "h-16 w-full"}`}
      data-testid={testid} data-mark={logoId && !failed ? "logo" : "name"}>
      {logoId && !failed
        ? <img src={mediaVariant(logoId, 320, "png")} alt={`${name} logo`} onError={() => setFailed(true)} className={`${big ? "max-h-12 max-w-[104px]" : "max-h-9 max-w-[80%]"} object-contain`} />
        : <span className={`max-w-[90%] truncate px-2 text-center font-semibold uppercase tracking-[0.14em] text-slate-500 ${big ? "text-sm" : "text-xs"}`}>{name}</span>}
    </div>
  );
};

const Lead = ({ b, L }) => (
  <div className="mb-6 flex min-h-[80px] flex-col gap-4 sm:flex-row sm:items-start" data-testid="brand-lead">
    {b ? <BrandMark name={b.display_name} logoId={b.logo_media_id} /> : <div className="h-20 w-32 shrink-0 rounded-xl bg-slate-100" aria-hidden="true" />}
    <div className="min-w-0">
      <p className="max-w-2xl text-slate-600" data-testid="brand-intro">{b ? b.intro : "\u00a0"}</p>
      {b?.top_categories?.length > 0 && (
        <div className="mt-3 flex flex-wrap gap-2" data-testid="brand-top-categories">
          {b.top_categories.map((c) => (
            <button key={c.slug} type="button" onClick={() => L.set("cat", c.slug)} data-testid={`brand-cat-${c.slug}`}
              className="rounded-full border border-slate-200 bg-white px-3 py-1.5 text-[13px] font-semibold text-slate-700 transition-colors duration-150 hover:border-[var(--brand-link)] hover:text-[var(--brand-link)]">
              {c.name} <span className="font-normal text-slate-400">{c.count.toLocaleString()}</span>
            </button>))}
        </div>)}
    </div>
  </div>
);

const Unavailable = () => <NothingNow what="brand" testid="brand-unavailable" />;

export default function BrandPage() {
  const { slug } = useParams();
  const L = useListing((params) => getBrand(slug, params), [slug]);
  const { data, loading, error } = L;
  const b = data?.brand;
  useEffect(() => {
    if (!data) return;
    document.title = `${b.display_name} - Rhyte Step IT`;
    const filtered = [...L.sp.keys()].some((k) => !["page"].includes(k));
    setPagedHead(`/brands/${slug}`, data.page || 1, data.total_pages || 1, filtered ? "noindex,follow" : "index,follow");
  }, [data, b, slug, L.sp]);
  return (
    <StoreLayout>
      <div className="mx-auto max-w-6xl px-5 py-8">
        {!loading && error && !data ? <Unavailable /> : (
          <ListingView L={L} prefix="brand" hideBrand title={b?.display_name} baseLabel="All categories" lead={<Lead b={b} L={L} />}
            crumbs={<nav className="mb-2 text-sm text-slate-500" aria-label="Breadcrumb"><Link to="/" className="hover:text-[var(--brand-link)]">Home</Link> / <Link to="/brands" className="hover:text-[var(--brand-link)]">Brands</Link>{b ? ` / ${b.display_name}` : ""}</nav>} />
        )}
      </div>
    </StoreLayout>
  );
}
